import React from 'react'
import Card from '../../../../components/Card'
import { Template } from '../../../../types/Individualization'
import Input from '../../../../components/Input'
import { useIndividualizationContext } from '../../../../contexts/individualizationContext'
import { useTranslation } from 'react-i18next'
import IconButton from '../../../../components/IconButton'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import cx from 'classnames'
import styles from './UploadTemplates.module.css'
import DropInput from '../../../../components/DropInput'

const TemplateCard: React.FC<Template> = ({ id, name, src, name_multi }) => {
    const { changeTemplateName, removeTemplate, uploadTemplate } =
        useIndividualizationContext()
    const { t } = useTranslation(['individualization'])

    const handleChange = (property: string, value: string) => {
        if (property === 'name') {
            changeTemplateName(id, value, name_multi)
        } else if (property === 'name_multi') {
            changeTemplateName(id, name, value)
        }
    }

    const handleDelete = () => {
        removeTemplate(id)
    }

    const handleImgChange = (base64: string) => {
        uploadTemplate(base64, id)
    }

    return (
        <Card
            title={name.length > 0 ? name : t('template_card.default_name')}
            classes={cx(styles['card-wrapper'])}
        >
            <IconButton
                icon={faTrashAlt}
                classes={cx(styles['card-icon'])}
                color={'#2f2f2f'}
                onClick={() => handleDelete()}
            />
            <DropInput
                onBase64Change={handleImgChange}
                accept={'image/*'}
                previewSrc={src}
                className={'zr-w-100 zr-mb-4'}
            />
            <div className={'zr-my-3'}>
                <Input
                    type={'text'}
                    placeholder={t('template_card.template_name')}
                    property={'name'}
                    value={name}
                    onChange={(property, value) =>
                        handleChange(property, value)
                    }
                    multiLanguage={true}
                    multiLanguageValue={name_multi}
                    onMultiLanguageChange={(property, value) =>
                        handleChange(property, value)
                    }
                />
            </div>
        </Card>
    )
}

export default TemplateCard
